import { Box, Typography } from '@mui/material'
import { colors } from '../../const/colors'

interface IAccessCardFormatProps {
  label: string
  number: string
  onPress: () => void
  highlighted?: boolean
}

const AccessCardFormat = ({
  label,
  number,
  onPress,
  highlighted,
}: IAccessCardFormatProps) => {
  const convertNumber = (v: string) => v.replace(/X/g, '8')

  return (
    <Box
      onClick={onPress}
      data-e2e={`card-format-${label}`}
      sx={{
        aspectRatio: '1.586 / 1',
        borderRadius: '16px',
        p: '18px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: 'pointer',
        transition: 'border-color .15s, box-shadow .15s',
        ...(highlighted
          ? {
              background: `linear-gradient(135deg,${colors.navyMid},${colors.navy})`,
              color: '#fff',
              boxShadow: colors.shadowCard,
            }
          : {
              background: colors.bg,
              border: `1px solid ${colors.border3}`,
              color: colors.navy,
              '&:hover': { borderColor: colors.navy },
            }),
      }}
    >
      <Typography sx={{ fontSize: '22px', fontWeight: 800, lineHeight: 1 }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: '12px',
          fontFamily: 'monospace',
          color: highlighted ? undefined : colors.textMuted,
          opacity: highlighted ? 0.9 : 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {convertNumber(number)}
      </Typography>
    </Box>
  )
}

export default AccessCardFormat
